import './styles/globals.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FontPicker from './components/FontPicker';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './components/auth/Register';
import TestPage from './pages/TestPage';
import Profile from './pages/Profile';
import PizzeriaDetail from './pages/PizzeriaDetail';
import PizzaDetail from './pages/PizzaDetail';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPizzas from './pages/admin/AdminPizzas';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import Preloader from './components/Preloader';
import ThemeSettings from './pages/admin/ThemeSettings';
import { ThemeProvider } from './contexts/ThemeContext';
import StaticPage from './components/StaticPage';
import PizzeriaManagement from './pages/pizzeria/PizzeriaManagement';

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <div className="min-h-screen flex flex-col bg-gray-50">
            <Preloader />
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/pizzerie/:id" element={<PizzeriaDetail />} />
                <Route path="/pizze/:id" element={<PizzaDetail />} />
                <Route path="/profile" element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                } />
                <Route path="/admin" element={
                  <PrivateRoute requiredRole="admin">
                    <AdminDashboard />
                  </PrivateRoute>
                } />
                <Route path="/admin/pizze" element={
                  <PrivateRoute requiredRole="admin">
                    <AdminPizzas />
                  </PrivateRoute>
                } />
                <Route path="/admin/pizzerie" element={
                  <PrivateRoute requiredRole="pizzeria">
                    <PizzeriaManagement />
                  </PrivateRoute>
                } />
                <Route path="/test" element={
                  <PrivateRoute requiredRole="admin">
                    <TestPage />
                  </PrivateRoute>
                } />
                <Route path="/admin/tema" element={
                  <PrivateRoute requiredRole="admin">
                    <ThemeSettings />
                  </PrivateRoute>
                } />
                <Route 
                  path="/il-progetto" 
                  element={<StaticPage slug="il-progetto" layout="narrow" />} 
                />
              </Routes>
            </main>
            <Footer />
            {process.env.NODE_ENV === 'development' && <FontPicker />}
          </div>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}